// @ts-strict-ignore
import classnames from 'classnames'
import { ScreenSize } from 'common_lib/types'
import { getScreenSize } from 'common_lib/utils'
import { Button, Text } from '@mytours/components'
import { defaultMapStyle, generateImageMapUrl, generateBoundsImageMapUrl } from 'mobile_web/modules/map/functions'
import { getDirMode } from 'mobile_web/modules/platform'
import strings from 'mobile_web/strings'
import { ScreenSection } from 'mytours-read-common'
import React, { useEffect, useState } from 'react'
import { GetScreensShowResponseSections, MapRoute } from 'mytours-read-api-typescript'
import MapPreviewComponent from 'mobile_web/modules/map/components/MapPreview'

interface Props {
	section: ScreenSection
	toggleMap: () => void
	setShowInAppDirections: (show: boolean) => void
}

enum ImageSize {
	Small = '500x500',
	Large = '1000x400',
}

const Content: React.FC<Props> = ({ section, toggleMap, setShowInAppDirections }) => {
	const [imageSize, setImageSize] = useState<ImageSize>(ImageSize.Small)

	const setLocationSizeCallback = (): void => {
		const screenSize = getScreenSize()

		if ([ScreenSize.md, ScreenSize.lg].includes(screenSize) && imageSize !== ImageSize.Large) {
			setImageSize(ImageSize.Large)
		} else if ([ScreenSize.sm].includes(screenSize) && imageSize !== ImageSize.Small) {
			setImageSize(ImageSize.Small)
		}
	}

	useEffect(() => {
		setLocationSizeCallback()
		addEventListener('resize', setLocationSizeCallback)

		return (): void => {
			removeEventListener('resize', setLocationSizeCallback)
		}
	}, [imageSize])

	const { title, display_address: displayAddress, lat, lng } = section

	const isMultipleLocationsMap = section.map_type === GetScreensShowResponseSections.MapTypeEnum.MultipleLocations

	const mapURL = isMultipleLocationsMap
		? generateBoundsImageMapUrl(section.map_items, defaultMapStyle, imageSize)
		: generateImageMapUrl(
				defaultMapStyle,
				lat,
				lng,
				imageSize,
				50,
				section.map_pin_icon,
				section.map_pin_style,
				section.map_pin_colour,
			)

	return (
		<div className="block-content" data-cy="story-screen-section-content">
			<div className="location-block">
				{isMultipleLocationsMap ? (
					<MapPreviewComponent
						section={section}
						items={section.map_items}
						details={section}
						linkedType={MapRoute.LinkedTypeEnum.StorySection}
						onClick={e => {
							e.preventDefault()
							toggleMap()
						}}
					/>
				) : (
					<img onClick={toggleMap} alt={title} src={mapURL} className="map" />
				)}
				{!isMultipleLocationsMap && (
					<div className="location-description">
						<Text variant="inherit">{displayAddress}</Text>
						<Button
							className={classnames('get-direction-button', getDirMode())}
							variant="clear"
							aria-label={strings.get_directions}
							onClick={(): void => setShowInAppDirections(true)}
						>
							<>
								<i className="fas fa-compass" />
								&nbsp;
								{strings.get_directions}
							</>
						</Button>
					</div>
				)}
			</div>
		</div>
	)
}

export default Content
